
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

function ModalAbout(props) {

    // const [open, setOpen] = React.useState(false);

    // const handleClickOpen = () => {
    //     setOpen(true);
    // };

    // const handleClose = () => {
    //     setOpen(false);
    // };

    return (
        <div>
            <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Acerca de</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    <b>Virtual Gallery</b> es una galeria virtual desarollada para 
                    Lanzarote Art Gallery por <i>iHM Solutions</i>. 
                </DialogContentText>
                <DialogContentText>
                    <p>Si necesita ayuda o reportar algon un error, pongase en contacto consotros en:   
                        <a href="mailto:support@ihm.solutions?subject=BUG: VG-Backend&body=Escribe aquí su problema" style={{'color':'slategray'}}>  support@ihm.solutions</a>
                    </p>
                </DialogContentText>
                {/* <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Email Address"
                    type="email"
                    fullWidth
                /> */}
                </DialogContent>
                <DialogActions>
                <Button onClick={props.handleClose} color="primary" variant="contained">
                    Cerrar
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default ModalAbout
